export function getHeaderBackHandler(state, options) {
    const { currentStep, selectedDoctor } = state;
    if (currentStep === "success" ||
        currentStep === "queue-confirmation") {
        return undefined;
    }
    if (currentStep !== "schedule") {
        return options.goBack;
    }
    if (selectedDoctor &&
        !options.isSolo &&
        !options.calendarOnly &&
        options.showDoctorPanel) {
        return options.deselectDoctor;
    }
    return undefined;
}
